import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', () => {
    // Check and initialize series slider
    const seriesSlider = document.querySelector('.abi-afrikaraoke-series-slider');
    if (seriesSlider) {
        new Splide('.abi-afrikaraoke-series-slider', {
            arrows: true,
            autoHeight: true,
            pagination: false,
            autoplay: true,
            type: 'loop',
            gap: 0,
            perPage: 1,
            padding: '0%',
        }).mount();
    }
    // Check and initialize host slider
    const hostSlider = document.querySelector('.abi-afrikaraoke-host-slider');
    if (hostSlider) {
        new Splide('.abi-afrikaraoke-host-slider', {
            arrows: false,
            autoHeight: true,
            pagination: true,
            autoplay: false,
            gap: 50,
            perPage: 5,
            padding: '0%',
            breakpoints: {
                767: {
                    gap: 10,
                    perPage: 1,
                    padding: '0%',
                    arrows: true,
                    pagination: false,
                },
            }
        }).mount();
    }
});
